// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"566":"fd12cd34","865":"701b9724"}[chunkId] + ".css";
};